export enum E_CHECKBOX_GROUP_EVENT {
  CHANGE = 'checkout-checkbox',
};

export enum E_CHECKBOX_EVENT {
  UPDATE_MODEL_VALUE = 'update-value',
};

export enum E_FINISH_BUTTON_EVENT {
  FINISH = 'finish',
};

export enum E_APPROVAL_REVIEW_EVENT {
  CHANGE_CHECKOUT_CHECKBOX = 'change-checkout-checkbox',
  CHECKOUT_FINISH = 'checkout-finish',
};

export enum E_EDITOR_VIEW_EVENT {
  CHANGE_CHECKOUT_CHECKBOX = 'change-checkout-checkbox',
  CHECKOUT_FINISH = 'checkout-finish',
  DUPLICATE = 'duplicate',
  CUSTOM_NEXT = 'custom-next',
};

export enum E_DATASHEET_VIEW_EVENT {
  CHANGE_CHECKOUT_CHECKBOX = 'change-checkout-checkbox',
  CHECKOUT_FINISH = 'checkout-finish'
};

export enum E_DATA_SHEET_CONTROLLER_EVENT {
  UPDATE_ROWS = 'update:rows',
  UPDATE_SELECTED_ROW_KEY = 'update:selected-row-key',
  UPDATE_CURRENT_SURFACE = 'update:current-surface',
  CLEAR_SHEETS = 'clear-sheets',
};

export enum E_FILE_UPLOADER_EVENT {
  UPDATE = 'upload',
  ERROR = 'error',
};

export enum E_DATA_TABLE_EVENT {
  UPDATE_SELECTED_ROW_KEY = 'update:selectedRowKey',
  UPDATE_MODEL = 'update:model',
};

export enum E_STEP_BUTTON_EVENT {
  CLICK = 'click',
};

export enum E_NEXT_BUTTON_EVENT {
  CLICK = 'click',
  CUSTOM_EVENT = 'custom-event',
};

export enum E_LIGHTBOX_EVENT {
  CLOSE = 'close',
};

export enum E_SHEET_PAGINATION_EVENT {
  PREV = 'prev-sheet',
  NEXT = 'next-sheet',
};

export enum E_DUPLICATE_BUTTON_EVENT {
  DUPLICATE = 'duplicate',
};

export enum E_STEPS_CONTROLLER_EVENT {
  CUSTOM_NEXT = 'custom-next',
}